var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngryUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.46,
    height: 23.45,
    viewBox: "0 0 20.46 23.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angry-user"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9,11.2h-.2a5.4,5.4,0,1,1,.2,0ZM8,5.8a3.78,3.78,0,0,0,3.7,3.8H12A3.8,3.8,0,1,0,8,5.8Z",
    transform: "translate(-2.19 -0.4)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2,22.8a5.23,5.23,0,0,1-2.9-3.6,5.56,5.56,0,0,1,1-4.5,8.48,8.48,0,0,1,10-2.4,1,1,0,0,1,.5,1.1.61.61,0,0,1-.9.5,7.27,7.27,0,0,0-8.5,2,3.36,3.36,0,0,0-.7,3,3.26,3.26,0,0,0,2,2.3,6.54,6.54,0,0,0,4.6.4.89.89,0,0,1,.4,1.7A7.88,7.88,0,0,1,5.2,22.8Z",
    transform: "translate(-2.19 -0.4)",
    fill: "{props.color}"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.6,17.7a5.91,5.91,0,0,1,5.9-5.9,5.9,5.9,0,0,1,0,11.8A5.91,5.91,0,0,1,10.6,17.7Zm.8,0a5.1,5.1,0,1,0,5.1-5.1A5.12,5.12,0,0,0,11.4,17.7Z",
    transform: "translate(-2.19 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.2,23.3c-.1-.1-.1-.1-.1-.2s.1-.1.2-.1a1.65,1.65,0,0,0,1.5-.9.76.76,0,0,0,.2-.5V17.5a1.6,1.6,0,0,1,1.3-1.6,1.8,1.8,0,0,1,2.1,1.3,1.72,1.72,0,0,1-1.4,2,1.65,1.65,0,0,1-1.5-.5l-.1-.1v2.6a3.92,3.92,0,0,1-1.8,2.1.56.56,0,0,1-.21.05A.43.43,0,0,1,11.2,23.3Zm3.5-7.2a1.35,1.35,0,1,0-.1,2.7A1.43,1.43,0,0,0,16,17.4,1.4,1.4,0,0,0,14.7,16.1Z",
    transform: "translate(-2.19 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,15.25c0,.05,0,.11,0,.13s-.13-.06-.15-.08a1.53,1.53,0,0,0-2-.1.19.19,0,0,1-.3,0l-.2-.2c-.1-.1-.1-.1,0-.2s.1-.1.2,0l.1.1a.1.1,0,0,1,.1.1h.1a1.82,1.82,0,0,1,.74-.3,1.49,1.49,0,0,1,1.41.46Z",
    transform: "translate(-2.19 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4,16.1a1.35,1.35,0,0,1,1.3,1.4,1.43,1.43,0,0,1-1.4,1.4A1.35,1.35,0,0,1,17,17.5,1.59,1.59,0,0,1,18.4,16.1Zm0,.4a1,1,0,1,0,1,1A.94.94,0,0,0,18.4,16.5Z",
    transform: "translate(-2.19 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,19.8a2,2,0,0,1,.84.1,2.78,2.78,0,0,1,.72.34.28.28,0,0,1,.1.08.27.27,0,0,1,0,.18s0,.05,0,.06-.14,0-.25-.06a1.6,1.6,0,0,0-.33-.19,2.36,2.36,0,0,0-.36-.11,2.07,2.07,0,0,0-1.56.2l-.08.05-.1.05c-.1.1-.2.1-.2,0a.12.12,0,0,1,0-.08.14.14,0,0,1,.07-.14,2.58,2.58,0,0,1,.42-.25,1.75,1.75,0,0,1,.4-.16A1.34,1.34,0,0,1,16.8,19.8Z",
    transform: "translate(-2.19 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4,17.7a.1.1,0,1,1,.1-.1A.1.1,0,0,1,18.4,17.7Z",
    transform: "translate(-2.19 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7,16.7a.8.8,0,1,1-.8.8A.79.79,0,0,1,14.7,16.7Zm.5.8a.5.5,0,1,0-.5.5C15,18.1,15.2,17.8,15.2,17.5Z",
    transform: "translate(-2.19 -0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7,17.4a.1.1,0,1,1-.1.1C14.6,17.4,14.6,17.4,14.7,17.4Z",
    transform: "translate(-2.19 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-2.19 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-2.19 -0.4)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53,23.3",
    transform: "translate(-2.19 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryUser);
export default __webpack_public_path__ + "static/media/angry-user.bd42b6429c2df7bfe5e311f831b9fc89.svg";
export { ForwardRef as ReactComponent };